import { Flex, FlexProps, Select } from '@chakra-ui/react'
import { SearchBar } from 'components'
import React from 'react'
import { SearchByType } from 'types'

type SmSearchBarProps = {
  placeholder?: string
  onSearch: (text: string) => void
  setSearchBy?: React.Dispatch<React.SetStateAction<SearchByType>>
  options?: Array<{ value: string; label: string }>
} & FlexProps
const SmSearchBar: React.FC<SmSearchBarProps> = ({
  onSearch,
  placeholder,
  setSearchBy,
  options,
  rounded,
  ...rest
}) => {
  return (
    <Flex align="center" rounded={rounded} {...rest}>
      <SearchBar placeholder={placeholder} rounded={rounded} onSearch={onSearch} />
      {options?.length ? (
        <Select
          ml={2}
          minW={32}
          rounded={rounded}
          fontWeight="semibold"
          fontSize="xs"
          variant="filled"
          w="fit-content"
          onChange={(e) => {
            setSearchBy?.(e.target.value as SearchByType)
          }}
        >
          {options?.map((option) => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      ) : null}
    </Flex>
  )
}
SmSearchBar.defaultProps = {
  placeholder: 'Search',
  rounded: 'full'
}

export default SmSearchBar
